import { useEffect, useState } from "react";
import {
  isRoamingEnabled,
  getMapMinZoom,
  subscribeToRuntimeFlags,
} from "./runtimeFlags";

/**
 * Re-render when the server's flags change.
 *
 * `isRoamingEnabled()` is readable from anywhere, but a component that calls
 * it during render will not re-render when it flips — so an admin turning the
 * beta off would leave every open session showing roaming UI until it happened
 * to re-render for some other reason. This subscribes so that does not happen.
 */
export const useRoamingEnabled = () => {
  const [enabled, setEnabled] = useState(isRoamingEnabled);

  useEffect(() => {
    // Read once on mount too: the server may have answered between the
    // useState initialiser and this effect.
    setEnabled(isRoamingEnabled());
    return subscribeToRuntimeFlags(() => setEnabled(isRoamingEnabled()));
  }, []);

  return enabled;
};

/** The map's zoom-out floor, re-rendering when an admin changes it. */
export const useMapMinZoom = () => {
  const [minZoom, setMinZoom] = useState(getMapMinZoom);

  useEffect(() => {
    setMinZoom(getMapMinZoom());
    return subscribeToRuntimeFlags(() => setMinZoom(getMapMinZoom()));
  }, []);

  return minZoom;
};

export default useRoamingEnabled;
